import $http from './http'
import config from './config'

export default {
    name: 'trainpolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getTrainNumber(data) {
        return $http.post(this.getUrl(`/TrainSearch/Search`), data);
    },
    getStationList(data) {
        return $http.post(this.getUrl(`/TrainSearch/Station`), data);
    },
    CreatePolicy(data){
        return $http.post(this.getUrl('/TrainPolicy/CreatePolicy'),data)
    },
    ProductInfo(data) {
        return $http.post(this.getUrl('/TrainPolicy/ProductInfo'), data);
    },
    ServiceFee(data){
        return $http.post(this.getUrl('/TrainPolicy/ServiceFee'),data);
    }
    ,
    validaccount(act,pwd){
        return $http.get(this.getUrl(`/TrainSearch/ValidAccount?account=${act}&password=${pwd}`))
    }
}



// WEBPACK FOOTER //
// ./src/apis/trainPolicyApi.js